<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

  import { EventTracking } from "@shared/services/event_tracking/events";
  import { updateProductLineListingStore } from "@retailer/svelte/ProductLines/ProductLineContainer/stores/ProductLineListingStore";

  import { ProductIndexLayoutEntity } from "@shared/services/event_tracking/entities";

  const { trackClick } = EventTracking;

  $: mobileMode = $LayoutStore.mobileMode;
  $: layoutButtonIconSize = mobileMode ? "18" : "16";

  let productListLayout: string = sessionStorage.getItem("product_list_layout") || "grid";

  const setLayout = layout => {
    productListLayout = layout;
    updateProductLineListingStore(s => {
      s.productListLayout = layout;
      return s;
    });
    trackClick("product_index_layout_toggle_button", new ProductIndexLayoutEntity({ layout }));
    sessionStorage.setItem("product_list_layout", layout);
  };
</script>

<div
  class:fizz-flex-row-4={mobileMode}
  class:fizz-flex-row-0={!mobileMode}
  data-testId="product-list-layout-buttons"
>
  <div class="fizz-tooltip-container" data-testId="grid-button-container">
    <button
      id="product-line-index-layout-grid-button"
      class="fizz-icon-button-small fizz-tooltip-trigger"
      on:click|preventDefault={() => setLayout("grid")}
      aria-describedby="tooltip-grid"
      data-testid="grid-layout-button"
    >
      <Icon
        type="LayoutGrid"
        height={layoutButtonIconSize}
        width={layoutButtonIconSize}
        extraStyles={productListLayout === "grid" ? "fill: black;" : "fill: grey;"}
      />
    </button>
    <div class="fizz-tooltip fizz-tooltip-top fizz-tooltip-center" role="tooltip" id="tooltip-grid">
      Grid
    </div>
  </div>
  <div class="fizz-tooltip-container" data-testId="list-button-container">
    <button
      id="product-line-index-layout-list-button"
      class="fizz-icon-button-small fizz-tooltip-trigger"
      on:click|preventDefault={() => setLayout("list")}
      aria-describedby="tooltip-list"
      data-testid="list-layout-button"
    >
      <Icon
        type="LayoutList"
        height={layoutButtonIconSize}
        width={layoutButtonIconSize}
        extraStyles={productListLayout === "list" ? "fill: black;" : "fill: grey;"}
      />
    </button>
    <div class="fizz-tooltip fizz-tooltip-top fizz-tooltip-center" role="tooltip" id="tooltip-grid">
      List
    </div>
  </div>
</div>
